export default "__VITE_ASSET__CkRxMXu___"